import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StorageModule } from '@cm/core/storage';
/**
 *
 * @deprecated Use @cm/core/storage StorageModule
 */
@NgModule({
	imports: [CommonModule, StorageModule],
})
export class AtsStoreModule {}
